const tickerNames = {
  V: "Visa",
  MA: "Mastercard",
  KO: "Coca-Cola",
  PEP: "PepsiCo",
  XOM: "Exxon Mobil",
  CVX: "Chevron",
  HD: "Home Depot",
  LOW: "Lowe's",
  F: "Ford Motor Company",
  GM: "General Motors",
  SLB: "Schlumberger",
  HAL: "Halliburton",
  JPM: "JPMorgan Chase",
  BAC: "Bank of America",
  MS: "Morgan Stanley",
  GS: "Goldman Sachs",
  PNC: "PNC Financial Services",
  TFC: "Truist Financial",
  DAL: "Delta Air Lines",
  UAL: "United Airlines",
  AAL: "American Airlines",
  UPS: "United Parcel Service",
  FDX: "FedEx",
  EOG: "EOG Resources",
  COP: "ConocoPhillips",
  MPC: "Marathon Petroleum",
  VLO: "Valero Energy",
  NUE: "Nucor",
  STLD: "Steel Dynamics",
  O: "Realty Income",
  NNN: "NNN REIT",
  PLD: "Prologis",
  DRE: "Duke Realty",
  CCI: "Crown Castle",
  AMT: "American Tower",
  BK: "Bank of New York Mellon",
  STT: "State Street",
  SCHW: "Charles Schwab",
  ETFC: "E*TRADE",

  NVDA: "NVIDIA",
  AMD: "Advanced Micro Devices",
  T: "AT&T",
  VZ: "Verizon",
  MCD: "McDonald's",
  YUM: "Yum! Brands",
  WFC: "Wells Fargo",
  C: "Citigroup",
  USB: "U.S. Bancorp",
  AVGO: "Broadcom",
  QCOM: "Qualcomm",
  TXN: "Texas Instruments",
  ADI: "Analog Devices",
  LMT: "Lockheed Martin",
  RTX: "RTX",
  NOC: "Northrop Grumman",
  UNH: "UnitedHealth Group",
  HUM: "Humana",
  SBUX: "Starbucks",
  MAR: "Marriott International",
  HLT: "Hilton Worldwide",
  PSA: "Public Storage",
  ECL: "Ecolab",
  LIN: "Linde",
  ADBE: "Adobe",
  CRM: "Salesforce",
  INTU: "Intuit",
  ADP: "Automatic Data Processing",
  BKNG: "Booking Holdings",
  EXPE: "Expedia",

  CAT: "Caterpillar",
  DE: "Deere & Company",
  COST: "Costco",
  WMT: "Walmart",
  TGT: "Target",
  NKE: "Nike",
  ADDYY: "Adidas",
  LULU: "Lululemon",
  CMG: "Chipotle Mexican Grill",
  BA: "Boeing",
  GD: "General Dynamics",
  NEE: "NextEra Energy",
  SO: "Southern Company",
  DUK: "Duke Energy",
  D: "Dominion Energy",
  AMZN: "Amazon",
  MSFT: "Microsoft",
  GOOGL: "Alphabet",
  META: "Meta Platforms",
  PFE: "Pfizer",
  MRK: "Merck",
  LLY: "Eli Lilly",
  NVO: "Novo Nordisk",
  DIS: "Disney",
  NFLX: "Netflix",
  COIN: "Coinbase",
  RIOT: "Riot Platforms",

  SPG: "Simon Property Group",
  AAPL: "Apple",
  TSM: "Taiwan Semiconductor",
  INTC: "Intel",
  BLK: "BlackRock",
  GE: "GE Aerospace",
  HON: "Honeywell",
  CMCSA: "Comcast",
  CROX: "Crocs",
  TSLA: "Tesla",
  APD: "Air Products and Chemicals",
  FCX: "Freeport-McMoRan",
  NEM: "Newmont",
  GOLD: "Barrick Gold",
  BHP: "BHP Group",

  MSTR: "MicroStrategy",
  MARA: "MARA Holdings",
  SMCI: "Super Micro Computer",
  DELL: "Dell Technologies",
  TTD: "The Trade Desk",
  LYV: "Live Nation Entertainment",
  KR: "Kroger",
  SHW: "Sherwin-Williams",
  ALB: "Albemarle",
  LAC: "Lithium Americas",
  PYPL: "PayPal",
  SQ: "Block",
  NOW: "ServiceNow",
  ORCL: "Oracle",
  DXCM: "DexCom",
  CI: "Cigna",
  BMY: "Bristol Myers Squibb",
  DHI: "D.R. Horton",
  LEN: "Lennar"
};

export default tickerNames;